export default "__VITE_ASSET__40e5a56b__"